import { PageEffects } from './page.effect';
import { UserEffects } from './user.effect';
import { RegisterEffect } from './register.effect';
import { MessageEffect } from './message.effect';
import { MeetingEffect } from './meeting.effect';
import { CampaignEffect } from './campaign.effect';
import { DatesEffect } from './dates.effect';
import { PipelineEffect } from './pipeline.effect';
import { ProductEffect } from './product.effect';

export const EFFECTS = [
  UserEffects,
  RegisterEffect,
  PageEffects,
  MessageEffect,
  MeetingEffect,
  CampaignEffect,
  DatesEffect,
  PipelineEffect,
  ProductEffect,
];
